import { render, staticRenderFns } from "./record-player.vue?vue&type=template&id=10c28031&scoped=true&"
import script from "./record-player.vue?vue&type=script&lang=js&"
export * from "./record-player.vue?vue&type=script&lang=js&"
import style0 from "./record-player.vue?vue&type=style&index=0&id=10c28031&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c28031",
  null
  
)

export default component.exports